import { useContext } from 'react'
import { Context } from 'commons/contexts/UserContext/context'

const useUser = () => {
  const user = useContext(Context)
  if (!user) {
    throw new Error('User Context not Found')
  }
  return user
}

export default useUser
